<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <!-- start: PAGE TITLE -->
      <section id="page-title" style="background-color: #d1d1d1;">
        <div class="row">
          <div class="col-sm-10">
            <h1 class="mainTitle">Deleted Appointment Days</h1>
          </div>
          <div class="col-sm-2">
            <router-link class="btn btn-primary" :to="{ name: 'all-appointmentDays' }">Back</router-link>
          </div>
        </div>
      </section>
      <!-- end: PAGE TITLE -->
      <!-- start: DYNAMIC TABLE -->
      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-12">
            <h5 class="over-title margin-bottom-15">
              <!-- Basic <span class="text-bold">Data Table</span> -->
              <!-- Deleted Appointment Days -->
            </h5>
            <p>

            </p>
            <div v-if="appointmentDays.length > 0">
              <MyTable :columns="columns" :actions="true">
                <tr v-for="(appointmentDay, index) in filteredAppointmentDays" :key="index">
                  <th scope="row">{{ appointmentDay.id }}</th>
                  <td>{{ appointmentDay.name_ar }}</td>
                  <td>{{ appointmentDay.name_en }}</td>
                  <td>{{ appointmentDay.available }}</td>
                  <td>
                    <button class="me-2 btn btn-success" @click="restoreAppointmentDay(appointmentDay.id)">
                      Restore
                    </button>

                  </td>
                </tr>
              </MyTable>
            </div>
            <div v-else class="alert alert-info">
              No deleted appointments found.
            </div>
          </div>
        </div>
      </div>
      <!-- end: DYNAMIC TABLE -->
    </div>
  </div>
</template>

<script>
import $ from 'jquery'; // Import jQuery
import MyTable from "../MyTable//MyTable.vue"; // Import your MyTable component
import axios from "../../Axios";
export default {
  name: "DeletedAppointmentDays",
  components: {
    MyTable,
    // Paginate,
  },
  data() {
    return {
      dataTable: [],
      appointmentDays: [],
      meta: {},
      searchTerm: "",
      columns: [
        { label: '#', key: 'id' },
        { label: 'Name Arabic', key: 'name_ar' },
        { label: 'Name English', key: 'name_en' },
        { label: 'Available', key: 'available' },
      ],
    };
  },

  async created() {
    this.fetchAppointmentDay();
  },

  computed: {
    filteredAppointmentDays() {
      if (!this.searchTerm) {
        return this.appointmentDays;
      }
      const term = this.searchTerm.toLowerCase();
      return this.appointmentDays.filter(
        (appointmentDay) =>
          appointmentDay.name.toLowerCase().includes(term) ||
          appointmentDay.postal_code.toLowerCase().includes(term)
      );
    },
  },

  methods: {
    // fetch medicationTypes
    async fetchAppointmentDay() {
      try {
        const response = await axios.get(
          `/admin/admin/appointment-day/get-delete-soft`
        );
        this.appointmentDays = response.data.data;
        this.meta = response.data.meta;
        this.$nextTick(() => {
          this.initializeDataTable(); // Initialize DataTable after fetching users
        });
      } catch (error) {
        console.error("Error fetching appointment day:", error);
      }
    },
    initializeDataTable() {
      this.$nextTick(() => {
        // Ensure the DataTable is initialized only after the DOM is updated
        $('.sample_1').DataTable(); // Initialize DataTable
      });
    },

    restoreAppointmentDay(id) {
      console.log("restore appointment id: ", id);
      axios.post(`/admin/admin/appointment-day/restore?id=${id}`)
        .then((response) => {
          console.log(response.data.data);
          this.fetchAppointmentDay();
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },

};
</script>
<style scoped>
.table {
  margin-top: 10px;
}

.spacing {
  margin-left: 10px !important;
}
</style>